import { Component } from '@angular/core';
import { NbDialogRef, NbCardModule, NbRadioModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';


@Component({
    selector: 'app-excel-explanations-dialog',
    templateUrl: './excel-explanations-dialog.component.html',
    styleUrls: ['./excel-explanations-dialog.component.scss'],
    standalone: true,
    imports: [NbCardModule, NbRadioModule, TranslateModule]
})
export class ExcelExplanationsDialogComponent {

  constructor(protected dialogRef: NbDialogRef<any>) {
  }

  public confirmed: boolean = false;

  public validate(): void {
    this.confirmed = true;
  }

  public close(): void {
    this.dialogRef.close();
  }

}
